import React from 'react';
import { connect } from 'react-redux';
import Logger, {LOG_LEVELS} from '../../../utils/logger';
import ReactTable from "react-table";
import LanguageStringResolver from '../../fields/language/LanguageStringResolver';
import Pagination from '../../page/Pagination'
import { withFullStoryExclude } from '../../../utils/fullStoryHelper';

const log = new Logger('EDITABLE_REVERSE_CHARGE_LISTING_LINES', LOG_LEVELS.DEBUG);
class EditableReverseChargeLisitingLines extends React.Component {
    constructor(props) {
        super(props);
    }

    onDelete(row, original, index) {
        this.props.onDelete(row, original, index, false, null, this.props.filingTypeId);
    }

    render() {
        const reverseChargeListingData = (this.props.reverseChargeListingData) || [];
       
        const getListingCols = () => {
            return [{
                Header: props => <LanguageStringResolver string='reverseChargeListingFilingReportType_VATNumber'/>,
                id :'vatNumber',
                accessor: 'vatNumber',
                filterable: true
            }, {
                Header: props => <LanguageStringResolver string='reverseChargeListingFilingReportType_Name'/>,
                id: 'name',
                accessor: 'name',
                filterable: true
            },
            {
                Header: props => <LanguageStringResolver string='reverseChargeListingFilingReportType_TotalAmountExclVAT'/>,
                id: 'taxableBasis',
                accessor:'taxableBasis',
                filterable: true,
                className: withFullStoryExclude(),
                headerClassName: withFullStoryExclude()
            },
            {
                Header: props => <LanguageStringResolver string='reverseChargeListingFilingReportType_TotalAmountVAT'/>,
                id: 'vatReversed',
                accessor:'vatReversed',
                filterable: true,
                className: withFullStoryExclude(),
                headerClassName: withFullStoryExclude()
            },
            {
                Header: props => <LanguageStringResolver string='reverseChargeListingFilingReportType_InOut'/>,
                id : 'lineTypeAsString',
                accessor: 'lineTypeAsString',
                filterable: true
            },
            {
                id: "checkbox",
                accessor: "SendingEnabled",
                Cell: ({row, original, index}) => {
                    return (
                        <button className="tertiary" onClick={(e) => {
                            this.props.onDelete(row, original, index, false, this.props.filingTypeId);
                        }}>
                            <LanguageStringResolver string='editableListingLines_Delete'/>
                        </button>
                    );
                },
                Header: props => <LanguageStringResolver string='editableListingLines_Delete'/>,
                className: 'text-align-center',
                width: 100,
                sortable: false
            }
            ]
        };
        return (
            <ReactTable
                data={reverseChargeListingData}
                columns={getListingCols()}
                defaultPageSize={20}
                pageSizeOptions={[ 20, 50, 100, 1000]}
                showPageJump={false}
                showPagination={true}
                PaginationComponent={Pagination}
                minRows={0}
                maxRows={0}
            />
        );
    }
}


EditableReverseChargeLisitingLines.defaultProps = {
    reverseChargeListingData : [],
    onDelete: () => {},
}

function mapStateToProps(state) {
    log.debug('mapStateToProps: ', state);
    return {
        languages: state.languages
    };
}

export default connect(mapStateToProps)(EditableReverseChargeLisitingLines);
